// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Internal_Queue from "../Specular.Internal.Queue/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var join = /* #__PURE__ */ Control_Bind.join(Specular_FRP_Base.bindDynamic);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var unless = /* #__PURE__ */ Control_Applicative.unless(Effect.applicativeEffect);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var discard2 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(Specular_FRP_Host.monadCleanupHost);
var Delayed = function (x) {
    return x;
};
var unwrapFunctorIdentity = {
    unwrapFunctor: function (v) {
        return v;
    }
};
var unwrapFunctorDelayedDelay = {
    unwrapFunctor: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var newtypeDelayed_ = {
    Coercible0: function () {
        return undefined;
    }
};
var functorDelayed = Specular_FRP_Base.functorDynamic;
var map = /* #__PURE__ */ Data_Functor.map(functorDelayed);
var hasFieldDelayedDelayed = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return map(getField(label));
        }
    };
};
var applyDelayed = Specular_FRP_Base.applyDynamic;
var applicativeDelayed = Specular_FRP_Base.applicativeDynamic;
var unwrapFunctor = function (dict) {
    return dict.unwrapFunctor;
};
var unsafeNewEmptyDelayed = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return Control_Bind.bind(Monad0.Bind1())(Specular_Ref["new"](dictMonadEffect)(Data_Maybe.Nothing.value))(function (ref) {
        var d = mapFlipped(Specular_Ref.value(ref))(function (v) {
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Partial_Unsafe.unsafeCrashWith("Accessed a Delayed too early! https://docs.manca.ro/Restaumatic_Form/Common_errors.html#accessed-a-delayed-too-early");
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Delayed (line 47, column 7 - line 49, column 154): " + [ v.constructor.name ]);
        });
        return pure1({
            delayed: d,
            fill: (function () {
                var $62 = write(ref);
                return function ($63) {
                    return $62(Data_Maybe.Just.create($63));
                };
            })()
        });
    });
};
var toDynamic = function (v) {
    return join(v);
};
var readDelayed = function (dictMonadEffect) {
    var readDynamic = Specular_FRP_Base.readDynamic(dictMonadEffect);
    return function (v) {
        return readDynamic(v);
    };
};
var isInitializingRef = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(/* #__PURE__ */ Effect_Ref["new"](false));
var afterInitializedQueue = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Specular_Internal_Queue["new"]);
var fixDelayed = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    var discard3 = discard(Bind1);
    var unsafeNewEmptyDelayed1 = unsafeNewEmptyDelayed(dictMonadEffect);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (f) {
        return bind2(liftEffect1(Effect_Ref.read(isInitializingRef)))(function (wasInitializing) {
            return discard3(liftEffect1(Effect_Ref.write(true)(isInitializingRef)))(function () {
                return bind2(unsafeNewEmptyDelayed1)(function (v) {
                    return bind2(f(v.delayed))(function (result) {
                        return discard3(liftEffect1(function __do() {
                            v.fill(result)();
                            unless(wasInitializing)(function () {
                                return Specular_Internal_Queue.drain(afterInitializedQueue, function (x) {
                                    return x();
                                });
                            })();
                            return Effect_Ref.write(wasInitializing)(isInitializingRef)();
                        }))(function () {
                            return pure1(result);
                        });
                    });
                });
            });
        });
    };
};
var afterInitializedE = function (eff) {
    return function __do() {
        var isInitializing = Effect_Ref.read(isInitializingRef)();
        if (isInitializing) {
            return Specular_Internal_Queue.enqueue(afterInitializedQueue, eff);
        };
        return eff();
    };
};
var afterInitialized = function (eff) {
    return bind1(liftEffect(Effect_Ref.read(isInitializingRef)))(function (isInitializing) {
        if (isInitializing) {
            return bind1(liftEffect(Effect_Ref["new"](pure(Data_Unit.unit))))(function (unsubRef) {
                return discard2(onCleanup(function __do() {
                    var unsub = Effect_Ref.read(unsubRef)();
                    Effect_Ref.write(pure(Data_Unit.unit))(unsubRef)();
                    return unsub();
                }))(function () {
                    return liftEffect(function () {
                        return Specular_Internal_Queue.enqueue(afterInitializedQueue, function __do() {
                            var v = Specular_FRP_Host.runHost(eff)();
                            return Effect_Ref.write(v.value1)(unsubRef)();
                        });
                    });
                });
            });
        };
        return eff;
    });
};
export {
    unwrapFunctor,
    Delayed,
    readDelayed,
    toDynamic,
    unsafeNewEmptyDelayed,
    fixDelayed,
    afterInitializedQueue,
    isInitializingRef,
    afterInitialized,
    afterInitializedE,
    functorDelayed,
    applyDelayed,
    applicativeDelayed,
    newtypeDelayed_,
    hasFieldDelayedDelayed,
    unwrapFunctorDelayedDelay,
    unwrapFunctorIdentity
};
